import { Component, Input, ViewEncapsulation, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { ImageInfoDetailBoxComponent } from '../image-info-detail-box/image-info-detail-box.component';
import { KYMW1600Model } from '../kymw1600.model';
import { KYMW1600Component } from '../kymw1600.component';

/**
 * 画像情報詳細部品を管理するクラス
 *
 * @export ImageInfoDetailComponent
 * @class ImageInfoDetailComponent
 */
@Component({
  selector: 'app-image-info-detail',
  templateUrl: 'image-info-detail.component.html',
  styleUrls: ['image-info-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImageInfoDetailComponent implements OnInit {
  @ViewChild('imageInfoDetailBox', { static: true }) imageInfoDetailBox: ImageInfoDetailBoxComponent;

  // イベント
  @Output() eventImageInfoDetailCHANGE: EventEmitter<any> = new EventEmitter;
  @Output() eventSettingCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventResetCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventUseStopCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventUseUnStopCLICK: EventEmitter<any> = new EventEmitter;
  @Output() eventDeleteCLICK: EventEmitter<any> = new EventEmitter;

  // レイアウト系の変数
  @Input() left: number = <number>0;
  @Input() top: number = <number>0;
  @Input() width: number = <number>100;
  @Input() height: number = <number>20;
  @Input() parentModel: KYMW1600Model;

  /** 画像のsrcのURLを保持 */
  @Input() imagePreviewURL = String('');

  /** ボタン非活性フラグ */
  public btnSettingEnabled: boolean = <boolean>false;
  public btnResetEnabled: boolean = <boolean>false;
  public btnUseStopEnabled: boolean = <boolean>false;
  public btnUseUnStopEnabled: boolean = <boolean>false;
  public btnDeleteEnabled: boolean = <boolean>false;

  // 親画面からの連携値
  param: any;

  constructor() {
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
  }
}
